import { useCallback, useState } from 'react';

const useToggle = (initialState?: boolean) => {
  const [toggleElement, setVisibility] = useState<boolean>(initialState || false);

  const toggle = useCallback((value?: boolean | ((prev: boolean) => boolean)) => {
    value !== undefined ? setVisibility(value) : setVisibility((prev) => !prev);
  }, []);

  return [toggleElement, toggle] as const;
};

export default useToggle;
